import React from 'react';

const LoaderPR = ({ showLoading }) => {
    return (showLoading &&  <div className="zds-page-loader">
        <span className="zds-spinner" />
      </div>);
}

export default LoaderPR;